var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgArrowLeftCircle = function SvgArrowLeftCircle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M22.001 12.001c0 5.523-4.478 10-10.001 10s-10-4.477-10-10S6.477 2.001 12 2s10 4.478 10.001 10.001m-1.2 0a8.802 8.802 0 1 0-17.603 0 8.802 8.802 0 0 0 17.604 0m-4.541 0a.5.5 0 0 1-.5.499H9.447l2.908 2.908a.5.5 0 0 1-.707.706l-3.76-3.76a.5.5 0 0 1-.064-.078l-.007-.013a.494.494 0 0 1 .07-.615l3.76-3.761a.5.5 0 0 1 .707.707l-2.908 2.908h6.316c.275 0 .499.223.499.499"
  })));
};
export default SvgArrowLeftCircle;